module.exports = __webpack_public_path__ + "img/tourne-standard.255ae855.png";